import { Box, Typography } from '@mui/material';
import type { OrderItemSummarySegment } from '../utils/orderItem/types';
import { SummarySegments } from './SummarySegments';

export function PresetSummary({
  name,
  segments,
  selected = false,
}: {
  name: string;
  segments: OrderItemSummarySegment[];
  selected?: boolean;
}) {
  return (
    <>
      <Typography variant="body2" fontWeight={selected ? 600 : 500} noWrap>
        {name}
      </Typography>
      <Box sx={{ mt: 0.25 }}>
        {segments.length ? (
          <SummarySegments segments={segments} />
        ) : (
          <Typography variant="caption" color="text.secondary">
            No values yet.
          </Typography>
        )}
      </Box>
    </>
  );
}
